import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../../shared/typings/vw-theme";

export const StyledGarageLayerWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  position: relative;
  height: 100svh;

  margin-top: ${(props) => props.theme.size.static350};

  @media (min-width: ${Breakpoints.b560}px) {
    margin-top: ${(props) => props.theme.size.static400};
  }
`;

export const StyledGarageCardsContainer = styled.div<{ 
  scroll: boolean; 
  hasScrolled: boolean; 
}>`
  ${({ theme, scroll, hasScrolled }: { theme: VWTheme, scroll: boolean, hasScrolled: boolean }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static250};
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding-bottom: 106px;

      @media (min-width: ${Breakpoints.b560}px) {
        padding-bottom: 115px;
      }

      @media (min-width: ${Breakpoints.b960}px) and (max-width: ${Breakpoints.b1280}px) {
        padding-bottom: 125px;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        padding-bottom: 145px;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding-bottom: 165px;
      }

      @media (min-width: ${Breakpoints.b2560}px) {
        padding-bottom: 180px;
      }
      
      -ms-overflow-style: none;
      scrollbar-width: none;
      
      &::-webkit-scrollbar {
        display: none;
      }
      
      ${scroll ? `
        ${hasScrolled ? `border-top: 2px solid ${theme.colors.border.divider};` : ''}
        margin-left: -4.16vw;
        margin-right: -4.16vw;
        padding-left: ${theme.size.grid001};
        padding-right: ${theme.size.grid001};
        padding-bottom: 180px;
      ` : ''}
    `;
  }}
`;

export const StyledFixedFooter = styled.div<{ scroll: boolean }>`
  ${({ theme, scroll }: { theme: VWTheme, scroll: boolean }) => {
    return `
      position: sticky;
      bottom: 0;
      ${scroll ? `border-top: 2px solid ${theme.colors.border.divider};` : ''}
      background: ${theme.colors.background.primary};
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static350};
      margin-left: -4.16vw;
      margin-right: -4.16vw;
      padding: ${theme.size.static350} ${theme.size.grid001};
      z-index: 10;

      button:hover svg path {
        fill: currentColor;
      }
    `;
  }}
`;
